import { Dialog, IconButton, Box, Tooltip } from "@mui/material";

import Close from "@mui/icons-material/Close";
import Download from "@mui/icons-material/Download";
import Print from "@mui/icons-material/Print";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";

import { Viewer, Worker, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { useMemo } from "react";
import "@react-pdf-viewer/core/lib/styles/index.css";

export default function PdfReportViewer({ open, onClose, fileUrl }) {
    const zoomPluginInstance = useMemo(() => zoomPlugin(), []);
    const { ZoomIn, ZoomOut } = zoomPluginInstance;

    const handleDownload = () => {
        if (!fileUrl) return;

        const link = document.createElement("a");

        link.href = fileUrl;
        link.download = "report.pdf";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handlePrint = () => {
        if (!fileUrl) return;

        const printWindow = window.open(fileUrl, "_blank");

        if (!printWindow) return;

        printWindow.addEventListener("load", () => {
            printWindow.print();
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={false}
            slotProps={{
                paper: {
                    sx: {
                        width: "90vw",
                        maxWidth: "1400px",
                        height: "90vh",
                        margin: 0,
                        overflow: "hidden"
                    }
                }
            }}
        >
            <Box
                sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden"
                }}
            >
                {/* Toolbar */}
                <Box
                    sx={{
                        height: 56,
                        minHeight: 56,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        px: 1,
                        borderBottom: 1,
                        borderColor: "divider",
                        flexShrink: 0,
                        zIndex: 1
                    }}
                >
                    <Tooltip title="Zoom out">
                        <ZoomOut>
                            {(props) => (
                                <IconButton
                                    onClick={props.onClick}
                                    disabled={props.disabled}
                                >
                                    <ZoomOutIcon />
                                </IconButton>
                            )}
                        </ZoomOut>
                    </Tooltip>

                    <Tooltip title="Zoom in">
                        <ZoomIn>
                            {(props) => (
                                <IconButton
                                    onClick={props.onClick}
                                    disabled={props.disabled}
                                >
                                    <ZoomInIcon />
                                </IconButton>
                            )}
                        </ZoomIn>
                    </Tooltip>
                    <Tooltip title="Download">
                        <IconButton onClick={handleDownload}>
                            <Download />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Print">
                        <IconButton onClick={handlePrint}>
                            <Print />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Close">
                        <IconButton onClick={onClose}>
                            <Close />
                        </IconButton>
                    </Tooltip>
                </Box>

                {/* PDF Viewer */}
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        overflow: "hidden"
                    }}
                >
                    {fileUrl && (
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                            <Viewer
                                fileUrl={fileUrl}
                                plugins={[zoomPluginInstance]}
                                //defaultScale={SpecialZoomLevel.PageFit}
                            />
                        </Worker>
                    )}
                </Box>
            </Box>
        </Dialog>
    );
}
